import {Button} from 'antd'
import http from '@/biz/http.mjs'
import {writeFileToDisk} from '@/script/file.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

// 导出结构：ss=程序结构（子系统），ua=界面结构（入口结构）
// mapTypeCode 为「制品图」自身的类型码（见 map/_SS_MAP.ftl、map/_UA_MAP.ftl），
// 而非列表级的 FC_MAP/UI_MAP，故以下划线开头。
const configs = {
    ss: {
        action: '导出程序结构',
        mapTypeCode: '_SS_MAP',
        url: '/archsss/exportSsStructure',
    },

    ua: {
        action: '导出界面结构',
        mapTypeCode: '_UA_MAP',
        url: '/archuas/exportUmStructure',
    },
}

export default function PropertiesPaneButtonExportStructure({type, ...props}) {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    const config = configs[type]

    // 仅在对应制品图（程序地图/界面地图）且单选节点时可用
    if (! (
        config &&
        1 === selectedNodes.size &&
        config.mapTypeCode === map.data.mapTypeCode
    )) {
        return null
    }

    const [node] = selectedNodes
    const {pkid} = node.data

    if (! pkid) {
        return null
    }

    const handleClick = async () => {
        const {blob, fileName} = await runAsync(
            () => http.get(config.url, {pkid}),
            {action: config.action}
        )

        writeFileToDisk(blob, {suggestedName: fileName})
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        />
    )
}
